import ParcelTemplate from '~/types/ParcelTemplate';
import { ActionKeys } from './constants';

export function closeModal() {
  return <const>{
    type: ActionKeys.SETTINGS_CLOSE_SAVE_PACKAGE_TEMPLATE_MODAL,
  };
}

export function openModal(parcelTemplate: Maybe<ParcelTemplate> = null) {
  return <const>{
    parcelTemplate,
    type: ActionKeys.SETTINGS_OPEN_SAVE_PACKAGE_TEMPLATE_MODAL,
  };
}

export type SettingsPackagesActions = ReturnType<typeof closeModal> | ReturnType<typeof openModal>;
